"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.3 19.276a3.2 3.2 0 0 1 3.2-3.2h2a3.2 3.2 0 0 1 3.2 3.2v.224a.7.7 0 1 1-1.4 0v-.224a1.8 1.8 0 0 0-1.8-1.8h-2a1.8 1.8 0 0 0-1.8 1.8v.224a.7.7 0 1 1-1.4 0zm4.2-7.326a1.19 1.19 0 1 1 0 2.38 1.19 1.19 0 0 1 0-2.38m2.59 1.19a2.59 2.59 0 1 0-5.18 0 2.59 2.59 0 0 0 5.18 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.36 9.19c-1.642-3.956-6.19-5.837-10.158-4.197s-5.85 6.175-4.208 10.13a7.76 7.76 0 0 0 5.093 4.503.7.7 0 0 1-.377 1.348A9.15 9.15 0 0 1 3.7 15.66C1.762 10.988 3.987 5.634 8.668 3.7c4.68-1.934 10.047.283 11.987 4.954q.183.44.317.89a.7.7 0 0 1-1.341.402 8 8 0 0 0-.27-.755m-7.183-2.415a.7.7 0 0 1 .7.7v4.28a1.7 1.7 0 0 1-1.7 1.7H8.531a.7.7 0 1 1 0-1.4h2.646a.3.3 0 0 0 .3-.3v-4.28a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=RequestsIcon24.js.map